import React, {forwardRef, useImperativeHandle, useState} from 'react'

const debug = false
// const debug = "MoreOptions"

export default forwardRef(function MoreOptions(props:any, ref: any) {

    const [value, setValue] = useState(0)

    useImperativeHandle(ref, () => ({
        setMoreOptions: (moreOptions: number = 0) => {
            debug && console.log(debug, 'setMoreOptions', moreOptions)
            setValue(moreOptions)
        }
    }))

    if (!value) return null

    return <div className="more-options ui5-link-small">{"+{0}".f(value)}</div>
})